import { useRef, useEffect } from 'react';
import paper from 'paper';

// Concentric circles that bulge toward a slow phantom cursor.
// Like Crumple, positions reset each frame so deformation oscillates.
const MeltPreview = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);
    const w = paper.view.size.width;
    const h = paper.view.size.height;
    const cx = w / 2, cy = h / 2;

    const colorDefs = ['pink', '#53DD6C', 'yellow', 'orange', '#53DD6C'];
    const segments = 80;
    const curves = [];
    const initPos = [];

    colorDefs.forEach((color, i) => {
      const curve = new paper.Path();
      curve.strokeColor = color;
      curve.strokeWidth = 8;
      const radius = 15 + i * Math.min(w, h) * 0.08;
      const pts = [];
      for (let j = 0; j < segments; j++) {
        const angle = (j / segments) * Math.PI * 2;
        const x = Math.sin(angle) * radius + cx;
        const y = Math.cos(angle) * radius + cy;
        curve.add(new paper.Point(x, y));
        pts.push({ x, y });
      }
      curves.push(curve);
      initPos.push(pts);
    });

    const onFrame = () => {
      const t = Date.now() * 0.002;
      const mx = cx + Math.sin(t * 1.2) * cx * 0.7;
      const my = cy + Math.cos(t * 0.8) * cy * 0.7;
      const mp = new paper.Point(mx, my);

      curves.forEach((curve, ci) => {
        curve.segments.forEach((seg, si) => {
          seg.point.x = initPos[ci][si].x;
          seg.point.y = initPos[ci][si].y;
          const dist = seg.point.getDistance(mp);
          const bend = 90 / (dist + 1);
          const dir = seg.point.subtract(mp).normalize();
          seg.point = seg.point.add(dir.multiply(bend));
        });
      });
    };

    paper.view.on('frame', onFrame);
    return () => { paper.view.off('frame', onFrame); paper.project.clear(); };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%', backgroundColor: 'white' }} />;
};

export default MeltPreview;
